import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AssessmentSetup } from '../../interfaces/career-setup/assessment-setup.interface';
import { PageResponse } from '../../interfaces/page-response.interface';
import { CommonSearchParam } from '../../interfaces/common-search-param.interface';
import { AssessmentSetupService } from './assessment-setup.service';

@Injectable({
  providedIn: 'root'
})
export class AssessmentSetupMockService extends AssessmentSetupService {
  private mockData: AssessmentSetup[] = [
    { uniqueId: 'ass-fe-apt', name: 'Frontend Aptitude', type: 'APTITUDE', description: 'General aptitude and logical reasoning for frontend roles.', noOfQuestions: 30, eta: 45, score: 100, experiencePoint: 50, orderNo: 1, roleUniqueId: 'role-fe', active: true } as any,
    { uniqueId: 'ass-fe-tech', name: 'Modern Web Tech', type: 'ONLINE_INTERVIEW', description: 'Deep dive into HTML, CSS, and JS.', noOfQuestions: 25, eta: 40, score: 100, experiencePoint: 60, orderNo: 2, roleUniqueId: 'role-fe', active: true } as any,
    { uniqueId: 'ass-fe-code', name: 'Angular/React Challenge', type: 'CODING_ROUND', description: 'Implement a small feature using a modern framework.', noOfQuestions: 3, eta: 90, score: 100, experiencePoint: 100, orderNo: 3, roleUniqueId: 'role-fe', active: true } as any,
    { uniqueId: 'ass-fe-hr', name: 'Frontend Culture Fit', type: 'ONLINE_INTERVIEW', description: 'Soft skills and behavioral assessment.', noOfQuestions: 10, eta: 20, score: 100, experiencePoint: 30, orderNo: 4, roleUniqueId: 'role-fe', active: true } as any,
    
    { uniqueId: 'ass-be-apt', name: 'Backend Aptitude', type: 'APTITUDE', description: 'General aptitude and logical reasoning for backend roles.', noOfQuestions: 30, eta: 45, score: 100, experiencePoint: 50, orderNo: 1, roleUniqueId: 'role-be', active: true } as any,
    { uniqueId: 'ass-be-tech', name: 'System Design Basics', type: 'ONLINE_INTERVIEW', description: 'API design and database architecture.', noOfQuestions: 20, eta: 40, score: 100, experiencePoint: 70, orderNo: 2, roleUniqueId: 'role-be', active: true } as any,
    { uniqueId: 'ass-be-code', name: 'API Implementation', type: 'CODING_ROUND', description: 'Build a RESTful API endpoint.', noOfQuestions: 2, eta: 120, score: 100, experiencePoint: 120, orderNo: 3, roleUniqueId: 'role-be', active: true } as any
  ];

  constructor() {
    super();
  }

  override findAll(params: any): Observable<PageResponse<AssessmentSetup>> {
    let filtered = [...this.mockData];
    if (params.roleUniqueId) {
      filtered = filtered.filter(a => (a as any).roleUniqueId === params.roleUniqueId);
    }
    if (params.searchTerm) {
      const term = params.searchTerm.toLowerCase();
      filtered = filtered.filter(a => a.name.toLowerCase().includes(term));
    }

    return of({
      content: filtered,
      page: {
        number: params.page || 0,
        size: params.size || 10,
        totalElements: filtered.length,
        totalPages: 1
      }
    });
  }

  override find(id: string): Observable<AssessmentSetup> {
    const item = this.mockData.find(i => i.uniqueId === id);
    return of(item as AssessmentSetup);
  }

  override create(data: Partial<AssessmentSetup>): Observable<AssessmentSetup> {
    const newItem = { ...data, uniqueId: 'mock-' + Date.now() } as AssessmentSetup;
    this.mockData.push(newItem);
    return of(newItem);
  }

  override update(id: string, data: Partial<AssessmentSetup>): Observable<AssessmentSetup> {
    const index = this.mockData.findIndex(i => i.uniqueId === id);
    if (index > -1) {
      this.mockData[index] = { ...this.mockData[index], ...data };
      return of(this.mockData[index]);
    }
    return of(data as AssessmentSetup);
  }

  override updateStatus(id: string, isActive: boolean): Observable<AssessmentSetup> {
    const index = this.mockData.findIndex(i => i.uniqueId === id);
    if (index > -1) {
      this.mockData[index] = { ...this.mockData[index], active: isActive };
      return of(this.mockData[index]);
    }
    return of({ active: isActive } as AssessmentSetup);
  }

  override delete(id: string): Observable<void> {
    this.mockData = this.mockData.filter(i => i.uniqueId !== id);
    return of(undefined);
  }
}
